<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :useRowIndex="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Name"
                        :label="$t('lang_CAPTION_NAME')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-name'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="otherPersonsTypeDropdownItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-type'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import { DropdownPublishingWorksOtherPersonsTypes } from '@/assets/dropdowns/alvDropdowns.js'

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "OtherPersonsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "WorksOtherPersons",
            alvqa: "publishing-works-edit-form-other-persons-panel-editing-dialog"
        }
    },
    computed: {
        otherPersonsTypeDropdownItems() { return DropdownPublishingWorksOtherPersonsTypes },
    }
}
</script>